import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import * as Styled from './ProductCallouts.styled';
/**
 * ProductCallouts component displays product callouts in a list format
 * with image on the left and label/sublabel on the right
 */
var ProductCallouts = function (_a) {
    var callouts = _a.callouts, className = _a.className, _b = _a.onPrimaryActionClick, onPrimaryActionClick = _b === void 0 ? undefined : _b;
    if (!callouts || callouts.length === 0) {
        return null;
    }
    return (React.createElement(Styled.CalloutsContainer, { onClick: onPrimaryActionClick, className: className },
        React.createElement(Styled.CalloutsList, null, callouts.map(function (callout, index) {
            var _a, _b, _c, _d, _e, _f, _g;
            return (React.createElement(Styled.CalloutItem, { key: index },
                callout.image && (React.createElement(Styled.CalloutImage, null,
                    React.createElement("img", { src: (_a = callout.image.file) === null || _a === void 0 ? void 0 : _a.url, alt: callout.image.title || callout.label || 'Product feature', width: (_d = (_c = (_b = callout.image.file) === null || _b === void 0 ? void 0 : _b.details) === null || _c === void 0 ? void 0 : _c.image) === null || _d === void 0 ? void 0 : _d.width, height: (_g = (_f = (_e = callout.image.file) === null || _e === void 0 ? void 0 : _e.details) === null || _f === void 0 ? void 0 : _f.image) === null || _g === void 0 ? void 0 : _g.height }))),
                React.createElement(Styled.CalloutContent, null,
                    callout.label && (React.createElement(Styled.CalloutLabel, null, callout.label)),
                    callout.sublabel && (React.createElement(Styled.CalloutSublabel, null, documentToReactComponents(callout.sublabel))))));
        }))));
};
ProductCallouts.displayName = 'ProductCallouts';
export default ProductCallouts;
